import { useState, useRef } from 'react';
import { downloadExcel, printTable } from '../../utils/exportUtils';

const rezervasyonlarData = [
  {
    id: 1,
    rezNo: '1361613',
    islemTarih: '04.09.2025 15:30',
    kanal: 'Otelfiyat',
    ad: 'AYDA',
    soyad: 'TÖRENLİ',
    giris: '05.09.2025',
    cikis: '06.09.2025',
    telefon: '05356337863',
    email: 'ayda.torenli@trt.net.tr',
    odaTip: '',
    konaklama: '',
    odemeTip: 'Skip',
    tutar: 2465.6,
    paraBirimi: 'TRY',
    krediKarti: '',
    durum: 'Onay bekliyor',
    kisiSayisi: 2,
    cocukSayisi: 0,
    ulke: 'TR',
    adres: 'Türkiye',
    acenteKodu: '1361613',
    acentePrefix: 'Ot',
    not: 'Booking ID: 1361613 Net Fiyat : 2465.60 TRYAcente Ödemeli İptal Edilemez Rezervasyon.Oda 1 için notlar : Misafir isimleri :-',
  },
  {
    id: 2,
    rezNo: '1361614',
    islemTarih: '04.09.2025 15:30',
    kanal: 'Otelfiyat',
    ad: 'AYDA',
    soyad: 'TÖRENLİ',
    giris: '05.09.2025',
    cikis: '06.09.2025',
    telefon: '05356337863',
    email: 'ayda.torenli@trt.net.tr',
    odaTip: '',
    konaklama: '',
    odemeTip: 'Skip',
    tutar: 2465.6,
    paraBirimi: 'TRY',
    krediKarti: '',
    durum: 'Onay bekliyor',
    kisiSayisi: 2,
    cocukSayisi: 0,
    ulke: 'TR',
    adres: 'Türkiye',
    acenteKodu: '1361614',
    acentePrefix: 'Ot',
    not: 'Booking ID: 1361614 Net Fiyat : 2465.60 TRYAcente Ödemeli İptal Edilemez Rezervasyon.Oda 1 için notlar : Misafir isimleri :-',
  },
  {
    id: 3,
    rezNo: '7516661',
    islemTarih: '04.09.2025 17:16',
    kanal: 'Expedia',
    ad: 'merve',
    soyad: 'Goktas',
    giris: '07.09.2025',
    cikis: '08.09.2025',
    telefon: '005070275141',
    email: '3c85qvwxhg@m.expediapartnercentral.com',
    odaTip: 'Triple Room Garden View (RoomCode)',
    konaklama: 'BB-NREF',
    odemeTip: 'CC',
    tutar: 77.8,
    paraBirimi: 'EUR',
    krediKarti: 'Kredi kartı',
    durum: 'Onaylandı',
    kisiSayisi: 3,
    cocukSayisi: 0,
    ulke: '',
    adres: '',
    acenteKodu: '2283036465',
    acentePrefix: 'Ex',
    not: 'Booking ID: 2283036465 1 Double Bed and 1 Large Twin BedNon-SmokingRemittance amount: 65.30, Expedia Virtual Card will be activated from the day of Check-in.BaseRateType : SellPaymentMethod : VirtualCardAmount to collect : 65.30 EUR (Net)Card Details: Card Activation Date : 2025-09-07T00:00:00ZAddress: 1111 Expedia Group Way W Seattle WA US 98119PromoNames for Room 1: %10 Erken rezervasyon-ContractedEXPEDIA_COLLECT',
  },
  {
    id: 4,
    rezNo: '7516662',
    islemTarih: '04.09.2025 17:16',
    kanal: 'Expedia',
    ad: 'merve',
    soyad: 'Goktas',
    giris: '07.09.2025',
    cikis: '08.09.2025',
    telefon: '005070275141',
    email: '3c85qvwxhg@m.expediapartnercentral.com',
    odaTip: 'Triple Room Garden View (RoomCode)',
    konaklama: 'BB-NREF',
    odemeTip: 'CC',
    tutar: 77.8,
    paraBirimi: 'EUR',
    krediKarti: 'Kredi kartı',
    durum: 'Onaylandı',
    kisiSayisi: 3,
    cocukSayisi: 0,
    ulke: '',
    adres: '',
    acenteKodu: '2283036466',
    acentePrefix: 'Ex',
    not: 'Booking ID: 2283036466 1 Double Bed and 1 Large Twin BedNon-SmokingRemittance amount: 65.30...',
  },
  {
    id: 5,
    rezNo: '6812345',
    islemTarih: '21.08.2025 14:43',
    kanal: 'website',
    ad: 'ahmet',
    soyad: 'tuncer',
    giris: '21.08.2025',
    cikis: '22.08.2025',
    telefon: '5321583488',
    email: 'mavinetcafe27@gmail.com',
    odaTip: 'Standart Oda',
    konaklama: 'Standart Fiyatlar',
    odemeTip: 'MO',
    tutar: 10,
    paraBirimi: 'TRY',
    krediKarti: '',
    durum: 'Onaylandı',
    kisiSayisi: 2,
    cocukSayisi: 0,
    ulke: 'TR',
    adres: '',
    acenteKodu: '',
    acentePrefix: '',
    not: '',
  },
  {
    id: 6,
    rezNo: '6812346',
    islemTarih: '20.08.2025 14:03',
    kanal: 'website',
    ad: 'hasan',
    soyad: 'tuncer',
    giris: '20.08.2025',
    cikis: '21.08.2025',
    telefon: '5321583488',
    email: 'mavinetcafe27@gmail.com',
    odaTip: 'Standart Oda',
    konaklama: 'Standart Fiyatlar',
    odemeTip: 'MO',
    tutar: 10,
    paraBirimi: 'TRY',
    krediKarti: '',
    durum: 'Onaylandı',
    kisiSayisi: 2,
    cocukSayisi: 0,
    ulke: 'TR',
    adres: '',
    acenteKodu: '',
    acentePrefix: '',
    not: '',
  },
];

const DURUM_SECENEKLER = ['Hepsi', 'Onay bekleyen', 'Onaylananlar', 'İptal edilenler', 'No-Show'];

function durumRenk(durum) {
  if (durum === 'Onaylandı') return 'bg-green-100 text-green-700';
  if (durum === 'Onay bekliyor') return 'bg-yellow-100 text-yellow-700';
  if (durum === 'İptal') return 'bg-red-100 text-red-700';
  return 'bg-gray-100 text-gray-600';
}

// ── Zengin Metin Editörü ──
function RichEditor({ value, readOnly }) {
  const editorRef = useRef(null);
  const savedRangeRef = useRef(null);
  const initializedRef = useRef(false);

  // İlk render'da içeriği bir kez set et, sonra React'ın müdahale etmesine izin verme
  function editorRefCallback(node) {
    if (node && !initializedRef.current) {
      node.innerHTML = value || '';
      initializedRef.current = true;
      editorRef.current = node;
    } else if (node) {
      editorRef.current = node;
    }
  }

  function saveSelection() {
    var sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
      savedRangeRef.current = sel.getRangeAt(0).cloneRange();
    }
  }

  function restoreSelection() {
    var editor = editorRef.current;
    if (!editor) return;
    editor.focus();
    if (savedRangeRef.current) {
      try {
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(savedRangeRef.current);
      } catch(e) {}
    } else {
      // Seçim yoksa imleci sona götür
      var range = document.createRange();
      range.selectNodeContents(editor);
      range.collapse(false);
      var sel2 = window.getSelection();
      sel2.removeAllRanges();
      sel2.addRange(range);
    }
  }

  function exec(cmd, val) {
    if (readOnly) return;
    restoreSelection();
    document.execCommand(cmd, false, val !== undefined ? val : null);
    editorRef.current && editorRef.current.focus();
  }

  function applyFontSize(e) {
    if (readOnly) return;
    var size = e.target.value;
    if (!size) return;
    restoreSelection();
    document.execCommand('fontSize', false, '7');
    var editor = editorRef.current;
    if (editor) {
      editor.querySelectorAll('font[size="7"]').forEach(function(el) {
        el.removeAttribute('size');
        el.style.fontSize = size;
      });
    }
    editor && editor.focus();
  }

  function applyColor(cmd, color) {
    if (readOnly) return;
    restoreSelection();
    document.execCommand(cmd, false, color);
    editorRef.current && editorRef.current.focus();
  }

  function insertLink() {
    if (readOnly) return;
    // Önce seçimi kaydet, sonra prompt aç
    var url = window.prompt('Link URL giriniz:');
    if (url) {
      restoreSelection();
      document.execCommand('createLink', false, url);
    }
  }

  var btn = 'px-1.5 py-0.5 text-xs rounded hover:bg-blue-100 text-gray-700 transition-colors flex items-center justify-center min-w-6 font-medium select-none cursor-pointer';
  var sep = 'w-px h-5 bg-gray-300 mx-1 flex-shrink-0';

  function tbBtn(cmdFn, title, children) {
    return (
      <button
        title={title}
        className={btn}
        onMouseDown={function(e) { e.preventDefault(); saveSelection(); }}
        onClick={cmdFn}
      >
        {children}
      </button>
    );
  }

  return (
    <div>
      <label className="text-xs text-gray-500 font-medium block mb-1">Not/Açıklama</label>
      <div className="border border-gray-300 rounded-t-lg px-2 py-1.5 bg-gray-50 flex items-center gap-0.5 flex-wrap">

        {/* Font boyutu */}
        <select
          onMouseDown={function() { saveSelection(); }}
          onChange={applyFontSize}
          disabled={readOnly}
          defaultValue=""
          className="text-xs border border-gray-200 rounded px-1 py-0.5 bg-white text-gray-700 focus:outline-none cursor-pointer mr-1">
          <option value="" disabled>Boyut</option>
          <option value="11px">Küçük</option>
          <option value="13px">Normal</option>
          <option value="16px">Orta</option>
          <option value="20px">Büyük</option>
          <option value="24px">Çok büyük</option>
        </select>

        <div className={sep} />

        {/* Başlıklar */}
        {tbBtn(function(){ exec('formatBlock', 'H1'); }, 'Başlık 1', <span className="font-bold text-sm">H1</span>)}
        {tbBtn(function(){ exec('formatBlock', 'H2'); }, 'Başlık 2', <span className="font-bold">H2</span>)}
        {tbBtn(function(){ exec('formatBlock', 'H3'); }, 'Başlık 3', <span className="font-bold text-xs">H3</span>)}
        {tbBtn(function(){ exec('formatBlock', 'P'); }, 'Normal paragraf', <span>¶</span>)}

        <div className={sep} />

        {/* Biçimlendirme */}
        {tbBtn(function(){ exec('bold'); }, 'Kalın (Ctrl+B)', <strong>B</strong>)}
        {tbBtn(function(){ exec('italic'); }, 'İtalik (Ctrl+I)', <em>I</em>)}
        {tbBtn(function(){ exec('underline'); }, 'Altı çizili', <span style={{textDecoration:'underline'}}>U</span>)}
        {tbBtn(function(){ exec('strikeThrough'); }, 'Üstü çizili', <span style={{textDecoration:'line-through'}}>S</span>)}

        <div className={sep} />

        {/* Listeler */}
        {tbBtn(function(){ exec('insertUnorderedList'); }, 'Madde listesi',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
            <circle cx="2" cy="3.5" r="1.2"/><rect x="5" y="2.8" width="8" height="1.4" rx="0.7"/>
            <circle cx="2" cy="7" r="1.2"/><rect x="5" y="6.3" width="8" height="1.4" rx="0.7"/>
            <circle cx="2" cy="10.5" r="1.2"/><rect x="5" y="9.8" width="8" height="1.4" rx="0.7"/>
          </svg>
        )}
        {tbBtn(function(){ exec('insertOrderedList'); }, 'Numaralı liste',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
            <text x="0.5" y="5" fontSize="4.5">1.</text><rect x="5" y="2.8" width="8" height="1.4" rx="0.7"/>
            <text x="0.5" y="8.5" fontSize="4.5">2.</text><rect x="5" y="6.3" width="8" height="1.4" rx="0.7"/>
            <text x="0.5" y="12" fontSize="4.5">3.</text><rect x="5" y="9.8" width="8" height="1.4" rx="0.7"/>
          </svg>
        )}

        <div className={sep} />

        {/* Hizalama */}
        {tbBtn(function(){ exec('justifyLeft'); }, 'Sola hizala',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><rect x="1" y="2" width="12" height="1.5" rx="0.75"/><rect x="1" y="5.25" width="8" height="1.5" rx="0.75"/><rect x="1" y="8.5" width="10" height="1.5" rx="0.75"/><rect x="1" y="11.75" width="6" height="1.5" rx="0.75"/></svg>
        )}
        {tbBtn(function(){ exec('justifyCenter'); }, 'Ortala',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><rect x="1" y="2" width="12" height="1.5" rx="0.75"/><rect x="3" y="5.25" width="8" height="1.5" rx="0.75"/><rect x="2" y="8.5" width="10" height="1.5" rx="0.75"/><rect x="4" y="11.75" width="6" height="1.5" rx="0.75"/></svg>
        )}
        {tbBtn(function(){ exec('justifyRight'); }, 'Sağa hizala',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><rect x="1" y="2" width="12" height="1.5" rx="0.75"/><rect x="5" y="5.25" width="8" height="1.5" rx="0.75"/><rect x="3" y="8.5" width="10" height="1.5" rx="0.75"/><rect x="7" y="11.75" width="6" height="1.5" rx="0.75"/></svg>
        )}
        {tbBtn(function(){ exec('justifyFull'); }, 'İki yana yasla',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><rect x="1" y="2" width="12" height="1.5" rx="0.75"/><rect x="1" y="5.25" width="12" height="1.5" rx="0.75"/><rect x="1" y="8.5" width="12" height="1.5" rx="0.75"/><rect x="1" y="11.75" width="6" height="1.5" rx="0.75"/></svg>
        )}

        <div className={sep} />

        {/* Girinti */}
        {tbBtn(function(){ exec('indent'); }, 'Girinti artır',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><rect x="1" y="2" width="12" height="1.5" rx="0.75"/><rect x="4" y="5.25" width="9" height="1.5" rx="0.75"/><rect x="4" y="8.5" width="9" height="1.5" rx="0.75"/><rect x="1" y="11.75" width="12" height="1.5" rx="0.75"/><path d="M1 6.5L3.5 8L1 9.5Z"/></svg>
        )}
        {tbBtn(function(){ exec('outdent'); }, 'Girinti azalt',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><rect x="1" y="2" width="12" height="1.5" rx="0.75"/><rect x="4" y="5.25" width="9" height="1.5" rx="0.75"/><rect x="4" y="8.5" width="9" height="1.5" rx="0.75"/><rect x="1" y="11.75" width="12" height="1.5" rx="0.75"/><path d="M4 6.5L1.5 8L4 9.5Z"/></svg>
        )}

        <div className={sep} />

        {/* Metin rengi — tıklayınca color picker aç */}
        <label
          title="Metin rengi"
          className={btn + ' relative'}
          onMouseDown={function(e) { e.preventDefault(); saveSelection(); }}
        >
          <span className="font-bold" style={{color:'#e53e3e', borderBottom:'2px solid #e53e3e', lineHeight:'1'}}>A</span>
          <input type="color" defaultValue="#e53e3e"
            style={{position:'absolute', opacity:0, width:'100%', height:'100%', top:0, left:0, cursor:'pointer'}}
            onChange={function(e){ applyColor('foreColor', e.target.value); }}
            disabled={readOnly} />
        </label>

        {/* Arkaplan rengi */}
        <label
          title="Arkaplan rengi"
          className={btn + ' relative'}
          onMouseDown={function(e) { e.preventDefault(); saveSelection(); }}
        >
          <span className="font-bold" style={{backgroundColor:'#fef08a', padding:'0 2px'}}>A</span>
          <input type="color" defaultValue="#fef08a"
            style={{position:'absolute', opacity:0, width:'100%', height:'100%', top:0, left:0, cursor:'pointer'}}
            onChange={function(e){ applyColor('hiliteColor', e.target.value); }}
            disabled={readOnly} />
        </label>

        <div className={sep} />

        {/* Link */}
        {tbBtn(insertLink, 'Link ekle',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5.5 8.5a3.5 3.5 0 0 0 5 0l1.5-1.5a3.5 3.5 0 0 0-5-5L6.5 2.5"/><path d="M8.5 5.5a3.5 3.5 0 0 0-5 0L2 7a3.5 3.5 0 0 0 5 5l.5-.5"/></svg>
        )}
        {tbBtn(function(){ exec('unlink'); }, 'Link kaldır',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5.5 8.5a3.5 3.5 0 0 0 5 0l1.5-1.5a3.5 3.5 0 0 0-5-5L6.5 2.5"/><path d="M8.5 5.5a3.5 3.5 0 0 0-5 0L2 7a3.5 3.5 0 0 0 5 5l.5-.5"/><line x1="2" y1="2" x2="12" y2="12"/></svg>
        )}

        {/* Biçim temizle */}
        {tbBtn(function(){ exec('removeFormat'); }, 'Biçimi temizle',
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 3l8 8M11 3L3 11"/></svg>
        )}

      </div>

      {/* contentEditable alan — ref callback ile yönetilir, React innerHTML'i ezmez */}
      <div
        ref={editorRefCallback}
        contentEditable={!readOnly}
        suppressContentEditableWarning={true}
        onMouseUp={saveSelection}
        onKeyUp={saveSelection}
        className={'w-full border border-t-0 border-gray-300 rounded-b-lg px-3 py-2 text-sm text-gray-700 focus:outline-none ' +
          (readOnly ? 'bg-gray-50 cursor-default' : 'bg-white focus:ring-2 focus:ring-blue-300')}
        style={{ minHeight: '140px' }}
      />
    </div>
  );
}

// ── Detay Modal ──
function DetayModal({ rez, onClose, onOnayla, onSil }) {
  const [form, setForm] = useState({
    rezNo: rez.rezNo,
    ad: rez.ad,
    soyad: rez.soyad,
    telefon: rez.telefon,
    email: rez.email,
    giris: rez.giris,
    cikis: rez.cikis,
    odaTip: rez.odaTip,
    konaklama: rez.konaklama,
    ulke: rez.ulke,
    tutar: rez.tutar,
    paraBirimi: rez.paraBirimi,
    krediKarti: rez.krediKarti || '',
    kisiSayisi: rez.kisiSayisi,
    cocukSayisi: rez.cocukSayisi,
    cocukYas: '',
    durum: rez.durum,
    kanal: rez.kanal,
    adres: rez.adres,
    acenteKodu: rez.acenteKodu,
    not: rez.not || '',
  });

  const onaylandi = rez.durum === 'Onaylandı';

  function handleChange(field, value) {
    // Onaylananlar sadece bilgi amaçlı, düzenlenemez
    if (onaylandi) return;
    setForm(function(prev) { return Object.assign({}, prev, { [field]: value }); });
  }

  // Düzenlenebilir input stili
  var editableClass = 'w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 bg-white text-gray-800';
  // Sadece okunur (Kanal, Durum, Ödeme tipi) stili
  var readonlyClass = 'w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-gray-100 text-gray-600 cursor-default select-none';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[70] flex items-start justify-center pt-6 px-4 overflow-y-auto"
      onClick={onClose}>
      <div className="bg-white w-full max-w-6xl rounded-xl shadow-2xl overflow-hidden mb-6"
        onClick={function(e) { e.stopPropagation(); }}>

        {/* Başlık */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-bold text-gray-800">{rez.ad} {rez.soyad} rezervasyonu</h2>
          <button onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-500 font-bold text-xl">
            ✕
          </button>
        </div>

        <div className="p-6 space-y-4">

          {/* Satır 1: Rez no, Ad, Soyad, Telefon, E-mail */}
          <div className="grid grid-cols-5 gap-4">
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Rezervasyon no</label>
              <input value={form.rezNo} onChange={function(e) { handleChange('rezNo', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Ad</label>
              <input value={form.ad} onChange={function(e) { handleChange('ad', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Soyad</label>
              <input value={form.soyad} onChange={function(e) { handleChange('soyad', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Telefon</label>
              <input value={form.telefon} onChange={function(e) { handleChange('telefon', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">E-mail</label>
              <input value={form.email} onChange={function(e) { handleChange('email', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
          </div>

          {/* Satır 2: Giriş, Çıkış, Oda tip, Konaklama türü, Ülke */}
          <div className="grid grid-cols-5 gap-4">
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Giriş</label>
              <input value={form.giris} onChange={function(e) { handleChange('giris', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Çıkış</label>
              <input value={form.cikis} onChange={function(e) { handleChange('cikis', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Oda tip</label>
              <input value={form.odaTip} onChange={function(e) { handleChange('odaTip', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Konaklama türü</label>
              <input value={form.konaklama} onChange={function(e) { handleChange('konaklama', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Ülke</label>
              <input value={form.ulke} onChange={function(e) { handleChange('ulke', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
          </div>

          {/* Satır 3 */}
          <div className="grid grid-cols-6 gap-4">
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Toplam tutar/Ödeme tip</label>
              <div className="flex gap-1">
                <input value={form.tutar} onChange={function(e) { handleChange('tutar', e.target.value); }}
                  readOnly={onaylandi} className={editableClass + ' flex-1'} />
                {/* Para birimi — readonly */}
                <input value={form.paraBirimi} readOnly className={readonlyClass + ' w-14'} />
                {/* Ödeme tipi — readonly */}
                {form.krediKarti && (
                  <input value={form.krediKarti} readOnly className={readonlyClass + ' w-24'} />
                )}
              </div>
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Kişi say./Çocuk say./Çocuk yaş.</label>
              <div className="flex gap-1">
                <input value={form.kisiSayisi} onChange={function(e) { handleChange('kisiSayisi', e.target.value); }}
                  readOnly={onaylandi} className={editableClass + ' w-full'} />
                <input value={form.cocukSayisi} onChange={function(e) { handleChange('cocukSayisi', e.target.value); }}
                  readOnly={onaylandi} className={editableClass + ' w-full'} />
                <input value={form.cocukYas} onChange={function(e) { handleChange('cocukYas', e.target.value); }}
                  readOnly={onaylandi} className={editableClass + ' w-full'} />
              </div>
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Durum</label>
              {/* Durum — her zaman readonly */}
              <input value={form.durum} readOnly className={readonlyClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Kanal</label>
              {/* Kanal — her zaman readonly */}
              <input value={form.kanal} readOnly className={readonlyClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Adres</label>
              <input value={form.adres} onChange={function(e) { handleChange('adres', e.target.value); }}
                readOnly={onaylandi} className={editableClass} />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-medium block mb-1">Acente/Acente kodu</label>
              <button
                onClick={function() {
                  if (form.acenteKodu) {
                    navigator.clipboard.writeText(form.acenteKodu);
                  }
                }}
                className="text-xs bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-lg px-2 py-1.5 text-gray-600 whitespace-nowrap w-full mb-1 transition-colors">
                Rez. no kopyala
              </button>
              {form.acenteKodu && (
                <div className="flex items-center gap-1">
                  <span className="text-xs font-semibold text-gray-500 bg-gray-100 border border-gray-200 rounded px-2 py-1.5 flex-shrink-0 whitespace-nowrap">
                    {rez.kanal}
                  </span>
                  <input value={form.acenteKodu} onChange={function(e) { handleChange('acenteKodu', e.target.value); }}
                    readOnly={onaylandi} className={editableClass + ' flex-1'} />
                </div>
              )}
            </div>
          </div>

          {/* Not/Açıklama — Zengin Editör */}
          <RichEditor value={form.not} readOnly={onaylandi} />
        </div>

        {/* Alt butonlar — Onaylananlar için hiçbir buton gösterilmez */}
        {!onaylandi && (
          <div className="px-6 pb-6 flex items-center justify-between">
            <button
              onClick={function() { onOnayla(rez.id, form); onClose(); }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg text-sm font-bold transition-colors">
              ONAYLA VE AKTAR
            </button>
            <button
              onClick={function() { onSil(rez.id); onClose(); }}
              className="bg-red-500 hover:bg-red-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold transition-colors">
              SİL
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Ana Sayfa ──
export default function GelenRezervasyonlar() {
  const [durumFiltre, setDurumFiltre] = useState('Hepsi');
  const [seciliRez, setSeciliRez] = useState(null);
  const [liste, setListe] = useState(rezervasyonlarData);

  // Elle filtreleme state'leri
  const [araRezNo, setAraRezNo] = useState('');
  const [araMisafir, setAraMisafir] = useState('');
  const [araGiris, setAraGiris] = useState('');
  const [araCikis, setAraCikis] = useState('');
  const [araGSaat, setAraGSaat] = useState('');
  const [araCSaat, setAraCSaat] = useState('');
  const [araGece, setAraGece] = useState('');
  const [araAcente, setAraAcente] = useState('');
  const [araDurum, setAraDurum] = useState('');

  var filtrelenmis = liste.filter(function(r) {
    // Dropdown filtre
    if (durumFiltre === 'Onay bekleyen' && r.durum !== 'Onay bekliyor') return false;
    if (durumFiltre === 'Onaylananlar' && r.durum !== 'Onaylandı') return false;
    if (durumFiltre === 'İptal edilenler' && r.durum !== 'İptal') return false;

    // Elle filtreler
    var adSoyad = (r.ad + ' ' + r.soyad).toLocaleLowerCase('tr-TR');
    if (araRezNo && r.rezNo.indexOf(araRezNo) < 0) return false;
    if (araMisafir && adSoyad.indexOf(araMisafir.toLocaleLowerCase('tr-TR')) < 0) return false;
    if (araGiris && r.giris.indexOf(araGiris) < 0) return false;
    if (araCikis && r.cikis.indexOf(araCikis) < 0) return false;
    if (araDurum && r.durum.toLocaleLowerCase('tr-TR').indexOf(araDurum.toLocaleLowerCase('tr-TR')) < 0) return false;
    if (araAcente && r.acenteKodu.indexOf(araAcente) < 0) return false;
    return true;
  });

  function handleOnayla(id, form) {
    setListe(function(prev) {
      return prev.map(function(r) {
        return r.id === id ? Object.assign({}, r, form, { durum: 'Onaylandı' }) : r;
      });
    });
  }

  function handleSil(id) {
    setListe(function(prev) { return prev.filter(function(r) { return r.id !== id; }); });
  }

  var filterInput = 'border border-gray-300 rounded px-2 py-1 text-xs focus:outline-none focus:border-blue-400 bg-white w-full';

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-xl font-bold text-gray-800">Gelen rezervasyonlar</h1>

      {/* Durum Filtresi */}
      <div>
        <label className="text-sm font-medium text-gray-700 block mb-1">Durum</label>
        <div className="flex items-center gap-2">
          <div className="relative">
            <select
              value={durumFiltre}
              onChange={function(e) { setDurumFiltre(e.target.value); }}
              className="border border-gray-300 rounded-lg px-3 py-2 pr-8 text-sm text-gray-700 bg-white focus:outline-none appearance-none min-w-44 cursor-pointer"
            >
              {DURUM_SECENEKLER.map(function(d) {
                return <option key={d} value={d}>{d}</option>;
              })}
            </select>
            <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-xs">▼</span>
          </div>
          <button className="bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-lg text-sm font-semibold transition-colors">
            Filtrele
          </button>
        </div>
      </div>

      {/* Tablo */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <span className="text-sm text-gray-600">Toplam {filtrelenmis.length} kayıt listelenmiştir.</span>
          <div className="flex gap-2">
            <button onClick={() => downloadExcel('gelen-rezervasyonlar', 'Rezervasyonlar', ['Rez. No','Kanal','Ad','Soyad','Giriş','Çıkış','Telefon','Ödeme Tipi','Tutar','Para Birimi','Durum','Kişi'], filtrelenmis.map(r => [r.rezNo, r.kanal, r.ad, r.soyad, r.giris, r.cikis, r.telefon, r.odemeTip, r.tutar, r.paraBirimi, r.durum, r.kisiSayisi]))} className="bg-green-600 hover:bg-green-700 text-white px-4 py-1.5 rounded-lg text-sm font-semibold">EXCEL</button>
            <button onClick={() => printTable('Gelen Rezervasyonlar', ['Rez. No','Kanal','Ad Soyad','Giriş','Çıkış','Telefon','Ödeme','Tutar','PB','Durum'], filtrelenmis.map(r => [r.rezNo, r.kanal, r.ad+' '+r.soyad, r.giris, r.cikis, r.telefon, r.odemeTip, r.tutar, r.paraBirimi, r.durum]), `${filtrelenmis.length} rezervasyon`)} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1.5 rounded-lg text-sm font-semibold">YAZDIR</button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              {/* Başlık Satırı */}
              <tr className="bg-gray-50 border-b border-gray-200">
                {['Rez. no', 'Misafirler', 'Oda', 'Giriş', 'G.Saat', 'Çıkış', 'Ç.Saat', 'Gece', 'Acente', 'Durum', 'Detay'].map(function(h) {
                  return (
                    <th key={h} className="text-left py-3 px-3 font-semibold text-white whitespace-nowrap text-xs">
                      {h}
                    </th>
                  );
                })}
              </tr>
              {/* Elle Filtreleme Satırı */}
              <tr className="bg-gray-50 border-b border-gray-200">
                <td className="px-2 py-1.5">
                  <input value={araRezNo} onChange={function(e) { setAraRezNo(e.target.value); }}
                    placeholder="Rez. no" className={filterInput} />
                </td>
                <td className="px-2 py-1.5">
                  <input value={araMisafir} onChange={function(e) { setAraMisafir(e.target.value); }}
                    placeholder="Misafirler" className={filterInput} />
                </td>
                <td className="px-2 py-1.5">
                  <input className={filterInput} placeholder="Oda" />
                </td>
                <td className="px-2 py-1.5">
                  <input value={araGiris} onChange={function(e) { setAraGiris(e.target.value); }}
                    placeholder="Giriş" className={filterInput} />
                </td>
                <td className="px-2 py-1.5">
                  <input value={araGSaat} onChange={function(e) { setAraGSaat(e.target.value); }}
                    placeholder="G.Saat" className={filterInput} />
                </td>
                <td className="px-2 py-1.5">
                  <input value={araCikis} onChange={function(e) { setAraCikis(e.target.value); }}
                    placeholder="Çıkış" className={filterInput} />
                </td>
                <td className="px-2 py-1.5">
                  <input value={araCSaat} onChange={function(e) { setAraCSaat(e.target.value); }}
                    placeholder="Ç.Saat" className={filterInput} />
                </td>
                <td className="px-2 py-1.5">
                  <input value={araGece} onChange={function(e) { setAraGece(e.target.value); }}
                    placeholder="Gece" className={filterInput} />
                </td>
                <td className="px-2 py-1.5">
                  <input value={araAcente} onChange={function(e) { setAraAcente(e.target.value); }}
                    placeholder="Acente" className={filterInput} />
                </td>
                <td className="px-2 py-1.5">
                  <input value={araDurum} onChange={function(e) { setAraDurum(e.target.value); }}
                    placeholder="Durum" className={filterInput} />
                </td>
                <td />
              </tr>
            </thead>
            <tbody>
              {filtrelenmis.length === 0 ? (
                <tr>
                  <td colSpan={11} className="text-center py-12 text-gray-400">
                    <div className="text-3xl mb-2">📋</div>
                    Kayıt bulunamadı
                  </td>
                </tr>
              ) : filtrelenmis.map(function(rez, i) {
                return (
                  <tr key={rez.id}
                    className={'border-b border-gray-100 hover:bg-blue-50 transition-colors ' + (i % 2 === 0 ? '' : 'bg-gray-50/40')}>
                    <td className="py-3 px-3 text-gray-700 text-xs font-mono">{rez.rezNo}</td>
                    <td className="py-3 px-3 text-gray-800 text-xs font-semibold whitespace-nowrap">{rez.ad} {rez.soyad}</td>
                    <td className="py-3 px-3 text-gray-600 text-xs max-w-28 truncate">{rez.odaTip}</td>
                    <td className="py-3 px-3 text-gray-600 text-xs whitespace-nowrap">{rez.giris}</td>
                    <td className="py-3 px-3 text-gray-500 text-xs">14:00</td>
                    <td className="py-3 px-3 text-gray-600 text-xs whitespace-nowrap">{rez.cikis}</td>
                    <td className="py-3 px-3 text-gray-500 text-xs">12:00</td>
                    <td className="py-3 px-3 text-gray-600 text-xs text-center">
                      {(function() {
                        try {
                          var g = rez.giris.split('.').reverse().join('-');
                          var c = rez.cikis.split('.').reverse().join('-');
                          var diff = (new Date(c) - new Date(g)) / 86400000;
                          return diff > 0 ? diff : '-';
                        } catch(e) { return '-'; }
                      })()}
                    </td>
                    <td className="py-3 px-3 text-gray-500 text-xs">{rez.acenteKodu}</td>
                    <td className="py-3 px-3">
                      <span className={'text-xs font-medium px-2 py-1 rounded-lg whitespace-nowrap ' + durumRenk(rez.durum)}>
                        {rez.durum}
                      </span>
                    </td>
                    <td className="py-3 px-3">
                      <button
                        onClick={function() { setSeciliRez(rez); }}
                        className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors">
                        Detay
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Detay Modal */}
      {seciliRez && (
        <DetayModal
          rez={seciliRez}
          onClose={function() { setSeciliRez(null); }}
          onOnayla={handleOnayla}
          onSil={handleSil}
        />
      )}
    </div>
  );
}